import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UserProfileComponent } from '../pages/user-profile/user-profile.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-openinvoiceprint',
  templateUrl: './openinvoiceprint.component.html',
  styleUrls: ['./openinvoiceprint.component.scss']
})
export class OpeninvoiceprintComponent implements OnInit {

  invoiceList: any[] = [];   // ✅ store multiple invoices
  toWords: ToWords;

  constructor(
    private dialogRef: MatDialogRef<UserProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data1: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.toWords = new ToWords({ 
      localeCode: 'en-IN', 
      converterOptions: { currency: true, ignoreDecimal: false } 
    });

    // Extract invoice numbers from passed data
    const invoice_nos = this.data1?.receiptdata?.map((item: any) => item.invoice_no) || [];

    if (invoice_nos.length > 0) {
      this.service.getdatabyinvoice1(invoice_nos).subscribe((res: any) => {
        if (res && res.length > 0) {
          // Store all invoices
          this.invoiceList = res.map((inv: any) => {
            const total_total = inv.invoice_items.reduce(
              (acc: number, item: any) => acc + parseFloat(item.total || 0),
              0
            );
            const shipping_charges_total = parseFloat(inv.invoice_header.total_shipping_charges || 0);
            const totals = total_total + shipping_charges_total;
            const amtinwords = this.toWords.convert(totals, { currency: true });

            return {
              ...inv,
              total_total,
              shipping_charges_total,
              totals,
              amtinwords
            };
          });
        }
      });
    }
  }

  print(): void {
    window.print();
  }

  close(): void {
    this.dialogRef.close();
  }
}
